import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { IoHome } from 'react-icons/io5';
import { BsPeopleFill } from 'react-icons/bs';
import { LuHistory } from 'react-icons/lu';
import { FaRegAddressCard } from 'react-icons/fa';
import powercabs from '../assets/powercabs-logo.svg';

const navConfig = [
  {
    title: 'Home',
    path: '/dashboard',
    icon: <IoHome width={21} />,
  },
  {
    title: 'Employee',
    path: '/employee',
    icon: <BsPeopleFill width={21} />,
  },
  {
    title: 'Ride History',
    path: '/ride-history',
    icon: <LuHistory width={21} />,
  },
  {
    title: 'Promotions',
    path: '/promotion',
    icon: <FaRegAddressCard width={21} />,
  },
];

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [companyName, setCompanyName] = useState('User');

  useEffect(() => {
    const storedCompanyName = localStorage.getItem('name') || 'User';
    setCompanyName(storedCompanyName);
  }, []);

  const location = useLocation();
  const navigate = useNavigate();

  const toggleDropdown = () => {
    setIsDropdownOpen((prevState) => !prevState);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    setIsDropdownOpen(false);
    navigate('/');
  };

  const isMobileView = window.innerWidth <= 768;

  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
      {isMobileView && isOpen ? (
        <button className='close-sidebar' onClick={toggleSidebar}>
          ✖
        </button>
      ) : (
        <div className='company-logo'>
          <img src={powercabs} alt='Company Logo' />
        </div>
      )}

      {navConfig.map((item, index) => {
        const isActive = location.pathname === item.path;
        return (
          <div key={index}>
            <Link
              to={item.path}
              className={isActive ? 'active-link' : 'link'}
              onClick={isMobileView ? toggleSidebar : null}
            >
              <span className='tab-icon'>{item.icon}</span>
              <span className='title'>{item.title}</span>
            </Link>
          </div>
        );
      })}

      <div className='sidebar-footer d-flex flex-column align-items-center justify-content-center text-center'>
        <div
          className='d-flex align-items-center justify-content-center'
          style={{ cursor: 'pointer', marginBottom: '75px' }}
          onClick={toggleDropdown}
        >
          <span className='title'>{companyName}</span>
          <span
            className='arrow-icon'
            style={{
              marginLeft: '10px',
              transform: isDropdownOpen ? 'rotate(90deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease',
              fontSize: '12px',
            }}
          >
            ▶
          </span>
        </div>

        {isDropdownOpen && (
          <div
            style={{
              position: 'absolute',
              top: '50px',
              // right: '0',
              background: '#fff',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              borderRadius: '8px',
              padding: '10px',
              zIndex: '1000',
              width: '150px',
            }}
          >
            <Link
              to='/profile'
              style={{
                padding: '2px',
                display: 'block',
                textDecoration: 'none',
                color: '#333',
              }}
              onClick={() => setIsDropdownOpen(false)}
            >
              Profile
            </Link>
            <button
              onClick={handleLogout}
              style={{
                padding: '2px',
                display: 'block',
                textDecoration: 'none',
                color: '#333',
                background: 'none',
                border: 'none',
                width: '100%',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
